import apiClient from '../lib/apiClient';

// Get attendance analytics
const getAnalytics = async (filters = {}) => {
  try {
    const result = await apiClient.get('/attendance-analytics', filters);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch analytics' };
  }
};

export default {
  getAnalytics
};

